import { render, staticRenderFns } from "./Form2.vue?vue&type=template&id=041e10b4&scoped=true&"
import script from "./Form2.vue?vue&type=script&lang=js&"
export * from "./Form2.vue?vue&type=script&lang=js&"
import style0 from "./Form2.vue?vue&type=style&index=0&id=041e10b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041e10b4",
  null
  
)

export default component.exports